__turbopack_context__.v({
  "className": "poppins_7e907b27-module__HxHCWq__className",
});
